import script from "./AboutFactory.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutFactory.vue?vue&type=script&setup=true&lang=js"

import "./AboutFactory.vue?vue&type=style&index=0&id=0f315e78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f315e78"]])

export default __exports__